import { api } from '../../ApiHandler';

type Props = { url: string; reference: string; meta?: string };
export const RegisterPageViewRequest = ({ url, reference, meta }: Props) => {
	return api()
		.post('usage/pages', { url, reference, meta })
		.then(response => response.data);
};
